export function reconcilePinnedPanes<T>(
  pinnedPanes: Map<number, T>,
  viewportCount: number
): Map<number, T> {
  const entries = [...pinnedPanes.entries()].sort((a, b) => a[0] - b[0]);
  const retained = entries.slice(0, viewportCount);
  const strays = retained.filter(([index]) => index >= viewportCount);

  if (retained.length === entries.length && strays.length === 0) {
    return pinnedPanes;
  }

  const next = new Map(retained.filter(([index]) => index < viewportCount));

  let slot = 0;
  strays.forEach(([, value]) => {
    while (next.has(slot)) slot += 1;
    next.set(slot, value);
    slot += 1;
  });
  return next;
}
